import React from 'react';
import { Lightbulb, Radio, Bell, Image } from 'lucide-react';

const Solution = () => {
  const features = [
    {
      icon: Radio,
      title: 'Kanal informasi terpusat dan konsisten'
    },
    {
      icon: Lightbulb,
      title: 'AI Agent aktif real-time selama acara'
    },
    {
      icon: Bell,
      title: 'Pengumuman serentak langsung ke peserta'
    },
    {
      icon: Image,
      title: 'Pengumpulan pesan, foto, dan video wisudawan'
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-sage-100 rounded-full mb-4">
            <span className="text-sm font-semibold text-sage-700 uppercase tracking-wide">Solusi</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Wisuda.ai
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Dirancang untuk menjadi pusat informasi dan interaksi resmi acara wisuda, 
            tanpa menambah beban teknis panitia.
          </p>
        </div>
        
        <div className="mb-12">
          <h3 className="text-2xl font-semibold text-gray-900 mb-8 text-center">
            Dengan Wisuda.ai, kampus mendapatkan:
          </h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="group flex items-center gap-4 p-6 bg-gradient-to-br from-sage-50 to-cream-50 rounded-xl border border-sage-200 hover:border-sage-400 transition-all duration-300 hover:shadow-md"
              >
                <div className="p-3 bg-white rounded-lg group-hover:scale-110 transition-transform">
                  <feature.icon className="w-6 h-6 text-sage-600" />
                </div>
                <p className="text-lg text-gray-800 font-medium">
                  {feature.title}
                </p>
              </div>
            ))}
          </div>
        </div>
        
        <div className="text-center p-8 bg-gradient-to-r from-sage-100 to-cream-100 rounded-2xl border border-sage-200">
          <p className="text-lg text-gray-800 mb-4">
            Semua berjalan melalui <span className="font-bold text-sage-700">WhatsApp</span>, 
            tanpa perlu aplikasi tambahan.
          </p>
          <button className="px-6 py-3 bg-sage-600 hover:bg-sage-700 text-white font-semibold rounded-full transition-all duration-300 shadow-md hover:shadow-lg">
            Coba Demo Wisuda.ai
          </button>
        </div>
      </div>
    </section>
  );
};

export default Solution;
